<template>
  <div class="columns is-vcentered has-text-centered not-found">
    <div class="column">
      <div class="box">
        <h1>העמוד שאתה מחפש לא קיים</h1>
        <router-link :to="{name: 'home'}"
                class="yoga-btn-purple">עבור לאימון שלי</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if (
      to.redirectedFrom === `/my-series` ||
      to.redirectedFrom === `/recommended`
    ) {
      next(`/`);
    }
    next();
  }
};
</script>

<style lang="scss">
.not-found {
  padding-top: 50px;
  h1 {
    font-size: 2.5rem;
  }
}
</style>
